<template>
    <div>
        <promo-banner-form :entity-id="entityId"></promo-banner-form>
    </div>
</template>

<script>
import PromoBannerForm from '@/components/pages/promoBanner/Form'
import dirtyForm from '@/components/mixins/dirtyForm'

export default {
    components: {
        PromoBannerForm,
    },
    mixins: [dirtyForm],

    data() {
        return {
            entityId: null,
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.entityId = route.params.id
            },
        },
    },
}
</script>
